import React, { PureComponent } from 'react'
import { constants, throttle } from 'common/helpers'
import { injectIntl, Message } from 'sb-react-intl'
import { Field as FormxField } from 'sb-formx'

import actions from 'redux/actions'

import { Button } from 'components/_new/controls'
import { Field } from 'components/_new/forms'
import { Box } from 'components/_new/layout'

import Modal from 'components/modal/Modal/Modal'
// TODO replace with the new checkbox - added on 2020-02-20 by maddoger
import Checkbox from 'components/forms/Checkbox/Checkbox'

import Contact from './Contact/Contact'

import messages from './messages'
import s from './ChooseFriendsToInviteModal.scss'


type Contact = {
  name: string
  email: string
  isActive?: boolean
}

type ChooseFriendsToInviteModalProps = {
  name: string
  data: Contact[]
  intl: ReactIntl
}

type ChooseFriendsToInviteModalState = {
  initContacts: Contact[]
  contacts: Contact[]
  isFetching: boolean
  isAllContactsChecked: boolean
}

class ChooseFriendsToInviteModal extends PureComponent<ChooseFriendsToInviteModalProps, ChooseFriendsToInviteModalState> {

  static defaultProps = {
    name: constants.modals.ChooseFriendsToInvite,
  }

  searchField = new FormxField('search', { value: '' })

  constructor({ data }) {
    // @ts-ignore
    super()

    this.state = {
      initContacts: data,
      contacts: data,
      limit: 50,
      isAllContactsChecked: false,
      isFetching: false,
    }

    this.contactsRef = React.createRef()
  }

  componentDidMount() {
    if (this.contactsRef.current) {
      this.contactsRef.current.addEventListener('scroll', this.handleContactsScroll)
    }
  }

  componentWillUnmount() {
    if (this.contactsRef.current) {
      this.contactsRef.current.removeEventListener('scroll', this.handleContactsScroll)
    }
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  handleContactsScroll = throttle((event: React.MouseEvent) => {
    const { limit, initContacts } = this.state
    const element = event.target

    if ((element.scrollHeight - element.scrollTop - element.clientHeight) <= 100) {
      if (limit < initContacts.length) {
        this.setState({
          limit: limit + 50,
        })
      }
    }
  }, 100)

  handleInputChange = (value: string) => {
    const { initContacts } = this.state
    const regexp = new RegExp(value, 'i')

    const filteredContacts = initContacts.filter(({ name, email }) => (
      regexp.test(name) || regexp.test(email)
    ))

    this.setState({
      contacts: filteredContacts,
      limit: 50,
    })
  }

  toggleContact = (index) => {
    const { contacts } = this.state

    const item = contacts[index]
    item.isActive = !item.isActive

    const newContacts = [
      ...contacts.slice(0, index),
      item,
      ...contacts.slice(index + 1),
    ]

    this.setState({
      contacts: newContacts,
    })
  }

  toggleContacts = () => {
    const { isAllContactsChecked, initContacts } = this.state

    const mapContacts = initContacts.map((contact) => ({ ...contact, isActive: !isAllContactsChecked }))

    this.setState({
      isAllContactsChecked: !isAllContactsChecked,
      contacts: mapContacts,
    })
  }

  sendInvitations = () => {
    const { contacts } = this.state

    const emails = contacts
      .filter((contact) => contact.isActive)
      .map((contact) => contact.email)

    if (!emails.length) {
      return
    }

    this.setState({ isFetching: true })

    actions.models.me.inviteUser(emails)
      .then(() => {
        actions.models.modals.open(constants.modals.Dialog, {
          contentMessage: messages.emailsWereSent,
          buttonTitle: messages.ok,
        })

        this.close()
      })
  }

  render() {
    const { isFetching, isAllContactsChecked, contacts, initContacts, limit } = this.state
    const { name } = this.props

    const areContactsExist = Boolean(contacts && contacts.length)

    return (
      <Modal
        className={s.modal}
        name={name}
        title={messages.title}
      >
        <Field
          placeholder={{ ...messages.searchContacts, values: { count: initContacts.length } }}
          field={this.searchField}
          standardView
          onChange={this.handleInputChange}
        />
        <Box ref={this.contactsRef} className={s.contacts} mt={24} mb={24}>
          {
            areContactsExist ? (
              contacts.slice(0, limit).map(({ isActive, name, email }, index) => (
                <Contact
                  key={`${name}-${email}`}
                  name={name}
                  email={email}
                  index={index}
                  isActive={isActive}
                  onChange={this.toggleContact}
                />
              ))
            ) : (
              <Message text={messages.noContacts} tag="div" />
            )
          }
        </Box>
        <div className={s.actions}>
          <div>
            <Checkbox
              className={s.checkbox}
              checked={isAllContactsChecked}
              label={isAllContactsChecked ? messages.uncheckAll : messages.checkAll}
              onChange={this.toggleContacts}
            />
          </div>
          <div className={s.buttons}>
            <Button
              title={messages.cancel}
              fullWidth
              color="transparent"
              size="md"
              onClick={this.close}
            />
            <Button
              className={s.sendButton}
              title={messages.send}
              fullWidth
              color="brand"
              size="md"
              disabled={isFetching}
              loading={isFetching}
              onClick={this.sendInvitations}
            />
          </div>
        </div>
      </Modal>
    )
  }
}


export default injectIntl(ChooseFriendsToInviteModal)
